import React from "react";
import Testimonial5 from "../../catalog/sections/Speakers1";
import Footer2 from "../../catalog/sections/Footer2";
import Intro from "./sections/Intro";
import Partners from "./sections/Partners";
import Services from "./sections/Services";
import Clients from "./sections/Clients";
// import WorkProcess1 from "../../catalog/sections/WorkProcess1";
import Blog1 from "../../catalog/sections/Blog1";
import Contact2 from "../../catalog/sections/Contact2";
import Portfolio from "../../catalog/sections/Portfolio2";
import firebase from './move-design.json';


export default () => {
  

  return (
    <>
      <Intro data={firebase.settings} />
      <Services data={firebase.menu.services}  />
      <Partners data={firebase.menu.partenaire}  />
      <Clients data={firebase.menu.clients}  />
      <Contact2 />
      <Footer2 />
    </>
  );
};

// import Testimonial5 from "../../catalog/sections/Testimonial4";